import { client } from './client';

export const handleAuthenticationRedirect = () => {
  const url = window.location.href;
  client.parseCognitoWebResponse(url);
};
